import io from 'socket.io-client';

import { SOCKET_EVENTS } from '../utils/constants';

//const BASE_URL = 'http://localhost:5000';
const BASE_URL = 'https://api.ringleader.cloud';

class SocketService {
  initializeSocket = async userId => {
    try {
      this.socket = io(BASE_URL, { secure: true, transports: ['websocket'] });
      this.socket.on(SOCKET_EVENTS.CONNECT, () => {
        console.log('Connected to server');
        this.emit(SOCKET_EVENTS.JOIN_ROOM, { userId });
      });

      this.socket.on(SOCKET_EVENTS.ERROR, data => {
        console.log('Error socket', data);
      });
    } catch (err) {
      console.log('error socket', err);
    }
  };

  emit = (event, data) => {
    try {
      this.socket.emit(event, data);
    } catch (err) {
      console.log('error emit socket', err);
    }
  };

  on = (event, callback) => {
    try {
      this.socket.on(event, callback);
    } catch (err) {
      console.log('error on socket', err);
    }
  };

  removeListener = listenerName => {
    try {
      this.socket.removeListener(listenerName);
    } catch (err) {
      console.log('error removeListener socket', err);
    }
  };
}

const socketService = new SocketService();

export default socketService;
